module.exports = __webpack_public_path__ + "img/Still-Thinking-1.a9d156fc.png";